import {
    Box,
    Flex,
    Grid,
    Paper,
    Text,
    Title
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { CustomLoader, RouteTitles } from "src/components";
import { useUpdateHead } from "src/hooks";
import { getTitleByLanguage } from "src/locales";
import { PanelNews } from "src/modules";
import { useGetNewsQuery } from "src/store";
import { Actions } from "./actions";
import { NewsDetailImage } from "./image";
import styles from "./styles.module.scss";
import { useEffect } from "react";

const options: Intl.DateTimeFormatOptions | undefined = {
    day: "numeric",
    month: "long",
    year: "numeric",
};

const NewsDetail = () => {
    const middleScreen = useMediaQuery("(max-width: 992px)")
    const { newsId } = useParams<string>();
    const navigate = useNavigate();
    const { data, isLoading, isError } = useGetNewsQuery(`${newsId}`, {
        skip: !newsId
    });
    useUpdateHead({
        title: getTitleByLanguage(data),
        description: `${getTitleByLanguage(data?.content)}`,
    });

    useEffect(() => {
        if(isError){
            navigate("/allnews")
        }
    }, [isError]);
    const date = new Date(`${data?.publishedAt}`).toLocaleString("ru", options)
    return (
        <>
            <Box className="container" mx="auto" mih="50vh">
                <RouteTitles
                    styles={{ mt: 120, mb: { base: 24, md: 40 } }}
                    title={`${getTitleByLanguage(data).slice(0, 20)}...`}
                />
                <Flex
                    className={styles.news_detail} direction="row"
                    gap={{ base: 24, md: 50 }}>
                    {isLoading ?
                        <Box pos="relative" w="100%" h={400}>
                            <CustomLoader />
                        </Box> :
                        <Flex direction="column" w="100%">
                            <Box className={styles.news_detail_header} >
                                <Flex
                                    align="center"
                                    justify="space-between"
                                    mb={16}
                                >
                                    <Paper
                                        variant="bordered"
                                        px={20}
                                        py={5}
                                        c={"#0A164F"}
                                    >
                                        {date}
                                    </Paper>
                                </Flex>
                                <Title fz={{ base: 18, lg: 24 }} lh={1.3} c="primaryDark">
                                    {getTitleByLanguage(data)}
                                </Title>
                            </Box>
                            <Grid
                                justify="space-between"
                                className={styles.news_detail_body}
                            >
                                <Grid.Col span={{ base: 12, lg: 7 }}>
                                    <NewsDetailImage photoAlbum={data?.photoAlbum} />
                                    {data ? (
                                        <Text c="primaryDark"
                                            dangerouslySetInnerHTML={{
                                                __html: getTitleByLanguage(data.content).replace(/font-size:[^;"]*/g, `font-size: ${middleScreen ? "16px" : "20px"}`)

                                            }} />
                                    ) : null}
                                    <Actions data={data} />
                                </Grid.Col>
                                <PanelNews />
                            </Grid>
                        </Flex>}
                </Flex>
            </Box>
        </>
    );
};



export default NewsDetail;
